export default __webpack_public_path__ + "treasure-picked-0682019da937df751930e3b53b530a09.mp3";